import { QueryClientProvider } from '@tanstack/react-query';

import { getQueryClient } from '@/utils/get-query-client';

import { IReactQueryClientProviderProps } from './react-query-client-provider.types';

function ReactQueryClientProvider({ children }: IReactQueryClientProviderProps) {
	const queryClient = getQueryClient();

	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

export default ReactQueryClientProvider;
